import { useGeolocation } from '@ocx-app/lib/geolocation/useGeolocation';

import { useMembership } from '@ocx/data-membership';
import { ScreenLoader } from '@ocx/ui';

import { createIframeUrl } from './order-ahead-provider.vroom.utils';
import { useVroomStorage } from './use-vroom-storage.hook';

type OrderAheadProviderVroomProps = {
  iframeUrlTemplate: string;
};
export const OrderAheadProviderVroom = (props: OrderAheadProviderVroomProps) => {
  const { iframeUrlTemplate } = props;
  const {
    membership: { id: membershipId },
  } = useMembership();

  const { lastVisitedUrl } = useVroomStorage({ iframeUrlTemplate });
  const { loading: isLocationLoading, coordinates } = useGeolocation();

  // When tab is become active, geolocation hook may trigger a refresh
  // and set loading to true while it fetches the updated location.
  // To avoid flickering, we only show the loader if we don't have coordinates yet.
  if (isLocationLoading && !coordinates) {
    return <ScreenLoader />;
  }

  const iframeUrl =
    lastVisitedUrl ||
    createIframeUrl({
      membershipId,
      urlTemplate: iframeUrlTemplate,
      location: coordinates,
    });

  return <iframe title="Order Ahead" src={iframeUrl} height="100%" width="100%" style={{ border: 'none' }} />;
};
